class ZoomGallery extends HTMLElement {
  constructor() {
    super();
    this.activeVideos = [];

    this.fauxPrev = this.querySelector(".swiper-faux-controls [data-prev]");
    this.fauxNext = this.querySelector(".swiper-faux-controls [data-next]");

    window.loadSwiper.then(({ Swiper }) => {
      this.Swiper = Swiper;

      this._initCarousel();
    });
  }

  _initCarousel() {
    const updateCurrentSlide = () => {
      if (!this.gallerySwiper) return;
      const activeSlide =
        this.gallerySwiper.slides[this.gallerySwiper.realIndex];

      this.gallerySwiper.slides.forEach((slide) => {
        if (slide == activeSlide) {
          activeSlide.removeAttribute("aria-hidden");
          activeSlide.querySelectorAll("a, button").forEach((el) => {
            el.tabIndex = null;
          });
        } else {
          slide.setAttribute("aria-hidden", "true");
          slide.querySelectorAll("a, button").forEach((el) => {
            el.tabIndex = -1;
          });
        }
      });
    };

    const swiperParams = {
      slidesPerView: "auto",
      initialSlide: this.dataset.preselectMediaIndex,
      speed: 400,
      watchSlidesProgress: true,
      keyboard: {
        enabled: true,
      },
      zoom: {
        limitToOriginalSize: true,
      },
      spaceBetween: 16,
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
        // dynamicBullets: true,
        // dynamicMainBullets: 3,
      },
      navigation: {
        nextEl: this.querySelector("[data-navigation-next]"),
        prevEl: this.querySelector("[data-navigation-previous]"),
      },
      init: false,
      on: {
        realIndexChange: () => updateCurrentSlide(),
      },
    };

    this.gallerySwiper = new this.Swiper(
      this.querySelector(`.${this._prefix}__media-container`),
      swiperParams,
    );

    updateCurrentSlide();

    const processVisibleSlides = () => {
      const visibleSlides = this.gallerySwiper.slides.filter((slide) =>
        slide.classList.contains("swiper-slide-visible"),
      );
      this._selectVideo(visibleSlides);
    };

    this.gallerySwiper.on("afterInit", processVisibleSlides);
    this.gallerySwiper.on("slideChange", processVisibleSlides);

    // this.fauxPrev.addEventListener("click", () => {
    //   this.gallerySwiper.slidePrev();
    // });

    // this.fauxNext.addEventListener("click", () => {
    //   this.gallerySwiper.slideNext();
    // });

    this.gallerySwiper.init();
  }

  _selectVideo(els) {
    this.activeVideos.forEach((video) => video.pause());

    this.activeVideos = [];

    els.forEach((el) => {
      const video = el.querySelector("video");

      if (video) {
        this.activeVideos.push(video);
        video.play();
      }
    });
  }

  get _prefix() {
    return this.dataset.classPrefix;
  }
}

if (!customElements.get("zoom-gallery")) {
  customElements.define("zoom-gallery", ZoomGallery);
}
